import React, { Component } from 'react'
import DataWrapper from '../../principal/containers/DataWrapper'
import VeiculosStore from '../stores/VeiculosStore'
import { Button, Container } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import FiltroVeiculos from '../components/FiltroVeiculos'
import GrupoCardsVeiculos from '../components/GrupoCardsVeiculos'
import Footer from '../../comum/components/Footer'
import FooterContent from '../../comum/components/FooterContent'

@inject("store")
@DataWrapper
@observer
export class Veiculos extends Component {

    constructor(props) {
        super(props)

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new VeiculosStore()
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Consulta de Veículos");
    }

    render() {
        return (
            <div>
                <Container fluid>
                    <FiltroVeiculos controller={this.controller} />
                    <GrupoCardsVeiculos controller={this.controller} />
                </Container>
                <Footer>
                    <FooterContent>
                        <div>
                            <b>{this.controller.totalPlacas}</b> 
                            {this.controller.totalPlacas === 1
                            ?" Veículo encontrado "
                            :" Veículos encontrados "
                            }
                            - <a className="btn-primary pl-0 pr-0" onClick={this.controller.listar}>Atualizar lista</a>
                        </div>
                    </FooterContent>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/veiculos/telas/Veiculos.js